import { CloseIcon } from "@/components/features/SquadBuilder/RightPanel/PanelHeader/PanelHeader";
import { cn } from "@/lib/utils";
import { topToPageSelector } from "@/redux/globalState/globalStateSlice";
import { useSelector } from "react-redux";

import { TopSectionCompressed, TopSectionProps } from "./TopSection";

interface MobileScrollTopSectionProps extends TopSectionProps {
  onClose: () => void;
}
export const MobileScrollTopSection = ({
  player,
  metaRating,
  metaRatingZeroChem,
  chemistry,
  chemStyleId,
  playerRoleId,
  onClose,
  scrollPastTopBar,
}: MobileScrollTopSectionProps) => {
  const topToPage = useSelector(topToPageSelector);
  return (
    <>
      <div className="h-12 w-full" />
      <div
        className={cn(
          "flex flex-row h-12 items-center justify-start gap-x-2 max-w-content mx-auto w-full pl-4 fixed left-0 right-0 z-11 bg-panel-base",
          topToPage.tailwindString,
        )}
      >
        {player && (
          <TopSectionCompressed
            playerName={player.name}
            metaRating={metaRating}
            scrollPastTopBar={scrollPastTopBar}
            metaRatingZeroChem={metaRatingZeroChem}
            playerRoleId={playerRoleId}
            version={{
              rating: player.rating,
              metalId: player.metalId,
              versionId: player.versionId,
              resourceId: player.resourceId,
            }}
            owned={player?.owned}
          />
        )}

        {onClose && (
          <button onClick={onClose} className="absolute right-0 p-4">
            <CloseIcon />
          </button>
        )}
      </div>
    </>
  );
};
